import React from 'react'
import { View, StyleSheet } from 'react-native'
import Colors from '../../../constants/Colors'
import CartFooter from './Footer'
import { useAppSelector } from '../../../state/hooks'
import { SCREEN_MAX_WIDTH } from '../../../constants/GlobalStyle'
import { useOrganizationStyles } from '../../../hooks/useOrganizationStyles'
const CheckoutColumns = ({
	children,
	prices,
	useColumnView,
	isRestaurantSnoozed,
	onCartPress,
	deliveryAmountToSpend,
	hasInvalidAddress,
	hasSelectedAddress,
}) => {
	const { isDelivery, cart } = useAppSelector(state => state.persisted)
	const { appBackground } = useOrganizationStyles()
	if (!useColumnView) {
		return children
	}

	return (
		<View style={{ ...styles.container, backgroundColor: appBackground }}>
			<View style={styles.mainContent}>{children}</View>
			<View style={styles.sidebar}>
				{!global.kiosk && cart.length > 0 && useColumnView && (
					<CartFooter
						prices={prices}
						useColumnView={useColumnView}
						isRestaurantSnoozed={isRestaurantSnoozed}
						onCartPress={onCartPress}
						showBanner={isDelivery && deliveryAmountToSpend !== 0 && !isNaN(deliveryAmountToSpend)}
						hasInvalidAddress={hasInvalidAddress}
						hasSelectedAddress={hasSelectedAddress}
					/>
				)}
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		width: '100%',
		minHeight: '100%',
		alignSelf: 'center',
		overflow: 'hidden',
		justifyContent: 'space-between',
		maxWidth: SCREEN_MAX_WIDTH - 64,
	},
	mainContent: {
		width: '55%',
	},
	sidebar: {
		width: '35%',
		marginRight: 16,
		marginTop: 70,
	},
})

export default CheckoutColumns
